<template>
    <div>
        <projeto
            v-show="mostrarProjeto"
            :projeto="projeto"
            :servicos="obterServicos()"
            :permiteAcessoRateio="false"
            rotaDetalhar="Sgtec_Gerentes_Etapa_Detalhar"
            :permiteAcessoDetalhar="$temAcessoView('SGTEC-GER-ETP-01')"
            :permiteExcluirComprometimento="false"
            :permiteAcessoErroComprometimento="
                $temAcessoView('SGTEC-GER-PRJ-01')
            "
            :permiteAcessoHistorico="$temAcessoView('SGTEC-GER-ETP-00')"
            @obterAtualizacao="obterProjeto()"
        >
            <template slot="projetoFooter">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </projeto>
        <router-view></router-view>
    </div>
</template>

<script>
import ProjetosServicos from './ProjetosServicos'
import Projeto from '@/app/sgtec/componentes/projetos/Projeto'

export default {
    data() {
        return {
            projeto: {}
        }
    },

    methods: {
        obterProjeto() {
            this.$store.dispatch('addRequest')
            ProjetosServicos.obterPorId(this.$route.params.projetoId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.projeto = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter projeto!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterServicos() {
            return ProjetosServicos
        }
    },

    computed: {
        mostrarProjeto() {
            return this.$route.name == 'Sgtec_Gerentes_Projetos_Detalhar'
        }
    },

    created() {
        this.obterProjeto()
    },

    components: {
        Projeto: Projeto
    }
}
</script>
